module.exports = __webpack_public_path__ + "img/Jump Casting66.37a58303.jpg";